module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "public-app"
  }, [_c('public-header', {
    attrs: {
      "locale": _vm.locale,
      "showdatepicker": _vm.showdatepicker,
      "date": _vm.datePickerDate
    },
    on: {
      "monthClick": _vm.toggleDatePicker,
      "menu": _vm.setMenu
    }
  }), _vm._v(" "), (_vm.showdatepicker) ? _c('pan-container', {
    attrs: {
      "active": _vm.isDatePickerReady,
      "date": _vm.datePickerDate,
      "theCalendarDate": _vm.date
    },
    on: {
      "changed": _vm.setDatePickerDate,
      "setDate": _vm.setDate
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showdatepicker) ? _c('v-touch', {
    staticClass: "overlay",
    on: {
      "tap": _vm.closeDatepicker
    }
  }) : _vm._e(), _vm._v(" "), (_vm.chosenView === 1) ? _c('day-selector', {
    attrs: {
      "date": _vm.date,
      "locale": _vm.locale
    },
    on: {
      "changed": _vm.setDate
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.load),
      expression: "load"
    }],
    staticClass: "load-spinner mobile"
  }, [_c('div', {
    staticClass: "icon-docendo animated pulse infinite"
  })]), _vm._v(" "), (_vm.chosenView === 1) ? _c('cal-container', {
    attrs: {
      "i18n": _vm.i18n,
      "locale": _vm.locale,
      "date": _vm.date,
      "dateChange": _vm.dateChange,
      "lessons": _vm.allEvents,
      "viewState": _vm.viewState
    },
    on: {
      "eventClicked": _vm.showEvent,
      "update:date": function($event) {
        _vm.date = $event
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.chosenView === 2) ? _c('weekplan', {
    attrs: {
      "calId": _vm.calId,
      "date": _vm.date,
      "events": _vm.allEvents,
      "locale": _vm.locale,
      "weeknote": _vm.weeknote
    },
    on: {
      "close": _vm.closeWeekPlan
    }
  }) : _vm._e(), _vm._v(" "), (_vm.chosenView === 3) ? _c('week-calendar', {
    attrs: {
      "calId": _vm.calId,
      "i18n": _vm.i18n,
      "date": _vm.date,
      "dateChange": _vm.dateChange,
      "lessons": _vm.allEvents,
      "weeknote": _vm.weeknote,
      "viewState": _vm.viewState,
      "locale": _vm.locale
    },
    on: {
      "eventClicked": _vm.showEvent,
      "update:date": function($event) {
        _vm.date = $event
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('footer-nav', {
    attrs: {
      "isNotToday": _vm.isNotToday
    },
    on: {
      "today": function($event) {
        return _vm.setDate(_vm.today)
      },
      "prev": _vm.prev,
      "next": _vm.next
    }
  }), _vm._v(" "), _c('sidenav', {
    attrs: {
      "menu": _vm.menu,
      "chosenView": _vm.chosenView,
      "schoolName": _vm.schoolName,
      "calName": _vm.calName
    },
    on: {
      "update:chosenView": function($event) {
        _vm.chosenView = $event
      },
      "update:chosen-view": function($event) {
        _vm.chosenView = $event
      },
      "close": function($event) {
        _vm.menu = false
      },
      "afterLeave": _vm.getView,
      "locale": _vm.setLocale
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0a698985!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/public/Mobile/MobileView.vue
// module id = 1468
// module chunks = 1